var lib_core     = require("lib-core");
var lib_geometry = require("lib-geometry");

var tooltipHelper = require("./tooltipHelper.js");

var TooltipModel = function() {
    lib_core.Model.apply(this,arguments);

    this.visible = this.value("visible", true);
    this.title = this.value("title", true);
    this.direction = this.value("direction", true);
    this.direction("w");
    this.position = this.value("position", true);
    this.position(new lib_geometry.Coord(100,100));
};

lib_core.inherit(TooltipModel, lib_core.Model);
TooltipModel.$class = "TooltipModel";

TooltipModel.prototype.getEventListenerHelper = function() {
    return tooltipHelper;
};

module.exports = TooltipModel;

